export default "__VITE_ASSET__84e94d57__"